// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/ppgatwick-ultra-light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/ppgatwick-bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/ppgatwick-jetextra-light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/ppgatwick-gliderextra-light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/ppgatwick-jumbosemi-bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/ppgatwick-jumboextra-light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/imgs/grid.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/imgs/menu_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'ppgatwick';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}
@font-face {
  font-family: 'ppgatwick-bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}
@font-face {
  font-family: 'ppgatwick-jetextralight';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
}
@font-face {
  font-family: 'ppgatwick-gliderextralight';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
}
@font-face {
  font-family: 'ppgatwick-jumbosemi-bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
}
@font-face {
  font-family: 'ppgatwick-jumboextra-light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
}
:root {
  --font-ppgatwick: 'ppgatwick', sans-serif;
  --font-ppgatwick-bold: 'ppgatwick-bold', sans-serif;
  --font-ppgatwick-jetextralight: 'ppgatwick-jetextralight', sans-serif;
  --font-ppgatwick-gliderextralight: 'ppgatwick-gliderextralight', sans-serif;
  --font-ppgatwick-jumbosemi-bold: 'ppgatwick-jumbosemi-bold', sans-serif;
  --font-ppgatwick-jumboextra-light: 'ppgatwick-jumboextra-light', sans-serif;
}
html[data-lang='vi'] {
  --font-ppgatwick: 'ppgatwick-jetextralight', sans-serif;
  --font-ppgatwick-bold: 'ppgatwick-bold', sans-serif;
  --font-ppgatwick-jetextralight: 'ppgatwick-jetextralight', sans-serif;
  --font-ppgatwick-gliderextralight: 'ppgatwick-gliderextralight', sans-serif;
  --font-ppgatwick-jumbosemi-bold: 'ppgatwick-jumbosemi-bold', sans-serif;
  --font-ppgatwick-jumboextra-light: 'ppgatwick-jumboextra-light', sans-serif;
}
.menuLayer__X5sIrxoDMz {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 110;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center center / cover, url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center center / cover;
  overflow-y: auto;
  padding-bottom: 0.5rem;
  overflow-x: hidden;
}
.menuLayerContent__P5J0g8CalC {
  width: 12.5rem;
  margin: 0 auto;
  margin-top: 0.8rem;
  padding-left: 1.2rem;
}
.menuItem__koGAcfO1Go {
  margin-bottom: 0.3rem;
  width: 100%;
}
.menuItem__koGAcfO1Go:last-child {
  margin-bottom: 0;
}
.menuItem__koGAcfO1Go .ant-image {
  opacity: 0;
  transition: all 0.15s ease;
  transform: translateX(-1.5rem);
}
.menuItem__koGAcfO1Go.active__ghoMm7oJL8 .ant-image,
.menuItem__koGAcfO1Go:hover .ant-image {
  opacity: 1;
  transform: translateX(0);
}
.menuItem__koGAcfO1Go h2 {
  color: #e9e9d7;
  margin: 0;
  margin-left: 0.42rem;
  font-size: 0.5rem;
  font-family: var(--font-ppgatwick);
  transition: color 0.1s ease-in-out;
  cursor: pointer;
}
.menuItem__koGAcfO1Go h2.orange__YXwPEwX9_X.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.orange__YXwPEwX9_X:hover {
  color: #ffb417;
}
.menuItem__koGAcfO1Go h2.cyan__D91AkCiipi.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.cyan__D91AkCiipi:hover {
  color: #00ffff;
}
.menuItem__koGAcfO1Go h2.green__IsGJlQrs69.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.green__IsGJlQrs69:hover {
  color: #8afd25;
}
.menuItem__koGAcfO1Go h2.yellow__p2yAJrkTIW.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.yellow__p2yAJrkTIW:hover {
  color: #fef038;
}
.menuItem__koGAcfO1Go h2.red__ZPSzSuwH_b.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.red__ZPSzSuwH_b:hover {
  color: #ff514f;
}
.menuItem__koGAcfO1Go h2.purple__m3vaPBNi6L.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.purple__m3vaPBNi6L:hover {
  color: #ff46ff;
}
.menuItem__koGAcfO1Go h2.blue__Yyy9SkWUJu.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.blue__Yyy9SkWUJu:hover {
  color: #0066ff;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/fonts.less","webpack://./src/components/MenuLayer/index.module.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,+DAAA;ACCF;ADEA;EACE,6BAAA;EACA,+DAAA;ACAF;ADGA;EACE,sCAAA;EACA,+DAAA;ACDF;ADIA;EACE,yCAAA;EACA,+DAAA;ACFF;ADKA;EACE,uCAAA;EACA,+DAAA;ACHF;ADMA;EACE,yCAAA;EACA,+DAAA;ACJF;ADeA;EACE,yCAAA;EACA,mDAAA;EACA,qEAAA;EACA,2EAAA;EACA,uEAAA;EACA,2EAAA;ACbF;ADiBA;EACE,uDAAA;EACA,mDAAA;EACA,qEAAA;EACA,2EAAA;EACA,uEAAA;EACA,2EAAA;ACfF;AApCA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,4JAAA;EAGA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAoCF;AAjCA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AAmCF;AAhCA;EACE,qBAAA;EACA,WAAA;AAkCF;AAhCE;EACE,gBAAA;AAkCJ;AAvCA;EASI,UAAA;EACA,0BAAA;EACA,8BAAA;AAiCJ;AA9BE;;EAGI,UAAA;EACA,wBAAA;AA+BN;AAjDA;EAuBI,cAAA;EACA,SAAA;EACA,oBAAA;EACA,iBAAA;EACA,kCAAA;EAEA,kCAAA;EACA,eAAA;AA4BJ;AAzBM;;EAEE,cAAA;AA2BR;AAtBM;;EAEE,cAAA;AAwBR;AAnBM;;EAEE,cAAA;AAqBR;AAhBM;;EAEE,cAAA;AAkBR;AAbM;;EAEE,cAAA;AAeR;AAVM;;EAEE,cAAA;AAYR;AAPM;;EAEE,cAAA;AASR","sourcesContent":["@font-face {\n  font-family: 'ppgatwick';\n  src: url('../fonts/ppgatwick-ultra-light.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ppgatwick-bold';\n  src: url('../fonts/ppgatwick-bold.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ppgatwick-jetextralight';\n  src: url('../fonts/ppgatwick-jetextra-light.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ppgatwick-gliderextralight';\n  src: url('../fonts/ppgatwick-gliderextra-light.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ppgatwick-jumbosemi-bold';\n  src: url('../fonts/ppgatwick-jumbosemi-bold.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ppgatwick-jumboextra-light';\n  src: url('../fonts/ppgatwick-jumboextra-light.otf') format('opentype');\n}\n\n// ============================================\n// CSS 变量定义 - 用于字体切换\n// ============================================\n\n// 系统字体回退\n@system-font: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;\n\n// 默认使用自定义字体的 CSS 变量\n:root {\n  --font-ppgatwick: 'ppgatwick', sans-serif;\n  --font-ppgatwick-bold: 'ppgatwick-bold', sans-serif;\n  --font-ppgatwick-jetextralight: 'ppgatwick-jetextralight', sans-serif;\n  --font-ppgatwick-gliderextralight: 'ppgatwick-gliderextralight', sans-serif;\n  --font-ppgatwick-jumbosemi-bold: 'ppgatwick-jumbosemi-bold', sans-serif;\n  --font-ppgatwick-jumboextra-light: 'ppgatwick-jumboextra-light', sans-serif;\n}\n\n// 越南语使用系统字体（ppgatwick 不支持越南语特殊字符）\nhtml[data-lang='vi'] {\n  --font-ppgatwick: 'ppgatwick-jetextralight', sans-serif;\n  --font-ppgatwick-bold: 'ppgatwick-bold', sans-serif;\n  --font-ppgatwick-jetextralight: 'ppgatwick-jetextralight', sans-serif;\n  --font-ppgatwick-gliderextralight: 'ppgatwick-gliderextralight', sans-serif;\n  --font-ppgatwick-jumbosemi-bold: 'ppgatwick-jumbosemi-bold', sans-serif;\n  --font-ppgatwick-jumboextra-light: 'ppgatwick-jumboextra-light', sans-serif;\n}\n","@import 'assets/styles/variables.less';\n@import 'assets/styles/fonts.less';\n\n.menuLayer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  z-index: 110;\n  background: url('assets/imgs/grid.png') no-repeat center center / cover,\n    url('assets/imgs/menu_bg.png') no-repeat center center / cover;\n\n  overflow-y: auto;\n  padding-bottom: 0.5rem;\n  overflow-x: hidden;\n}\n\n.menuLayerContent {\n  width: 12.5rem;\n  margin: 0 auto;\n  margin-top: 0.8rem;\n  padding-left: 1.2rem;\n}\n\n.menuItem {\n  margin-bottom: 0.3rem;\n  width: 100%;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  :global(.ant-image) {\n    opacity: 0;\n    transition: all 0.15s ease;\n    transform: translateX(-1.5rem);\n  }\n\n  &.active,\n  &:hover {\n    :global(.ant-image) {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  h2 {\n    color: @color_white;\n    margin: 0;\n    margin-left: 0.42rem;\n    font-size: 0.5rem;\n    font-family: var(--font-ppgatwick);\n    // line-height: 1em;\n    transition: color 0.1s ease-in-out;\n    cursor: pointer;\n\n    &.orange {\n      &.active,\n      &:hover {\n        color: #ffb417;\n      }\n    }\n\n    &.cyan {\n      &.active,\n      &:hover {\n        color: #00ffff;\n      }\n    }\n\n    &.green {\n      &.active,\n      &:hover {\n        color: #8afd25;\n      }\n    }\n\n    &.yellow {\n      &.active,\n      &:hover {\n        color: #fef038;\n      }\n    }\n\n    &.red {\n      &.active,\n      &:hover {\n        color: #ff514f;\n      }\n    }\n\n    &.purple {\n      &.active,\n      &:hover {\n        color: #ff46ff;\n      }\n    }\n\n    &.blue {\n      &.active,\n      &:hover {\n        color: #0066ff;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuLayer": `menuLayer__X5sIrxoDMz`,
	"menuLayerContent": `menuLayerContent__P5J0g8CalC`,
	"menuItem": `menuItem__koGAcfO1Go`,
	"active": `active__ghoMm7oJL8`,
	"orange": `orange__YXwPEwX9_X`,
	"cyan": `cyan__D91AkCiipi`,
	"green": `green__IsGJlQrs69`,
	"yellow": `yellow__p2yAJrkTIW`,
	"red": `red__ZPSzSuwH_b`,
	"purple": `purple__m3vaPBNi6L`,
	"blue": `blue__Yyy9SkWUJu`
};
export default ___CSS_LOADER_EXPORT___;
